import classNames from 'classnames';
import Link from 'components/gruenland/atoms/link';
import { COMPANY_ADDRESS, COMPANY_FAX, COMPANY_NAME, COMPANY_PHONE, COMPANY_VAT_CODE } from 'project.config';
import { FooterLink } from './atoms/Column1';
import { FooterBottomItem } from './atoms/FooterBottomItem';
import { SocialLinkIcons } from './atoms/SocialLinkIcons';

export interface Props {
  legalMenuItems: FooterLink[];
  className?: string;
}

const FooterBottom: React.FC<Props> = ({ legalMenuItems, className }) => {
  return (
    <div className={classNames('flex items-center justify-between gap-[15px]', className)}>
      <div className="flex flex-col gap-[5px] md:flex-row md:items-center md:gap-[60px]">
        <FooterBottomItem>® {COMPANY_NAME}</FooterBottomItem>
        <FooterBottomItem>P.Iva {COMPANY_VAT_CODE}</FooterBottomItem>
        <FooterBottomItem className="md:hidden">{COMPANY_ADDRESS}</FooterBottomItem>
        <FooterBottomItem className="md:hidden">Tel. {COMPANY_PHONE}</FooterBottomItem>
        <FooterBottomItem className="md:hidden">Fax. {COMPANY_FAX}</FooterBottomItem>
        {legalMenuItems.map((item, i) => (
          <FooterBottomItem key={i} className="hidden md:block">
            <Link link={item.reference}>{item.name}</Link>
          </FooterBottomItem>
        ))}
      </div>
      <SocialLinkIcons className="hidden md:flex" />
    </div>
  );
};

export default FooterBottom;
